import { COMMON_PAGE_LIMIT, prepareIdsForChunking } from '@wix/a11y-wizard-common';
import { queryGroups } from '@wix/ambassador-social-groups-v2-group/http';
import { ContentType } from '@wix/ambassador-social-groups-v2-group/types';
export const fetchGroups = async (httpClient, errorHandler, ids) => {
  const {
    withErrorHandler
  } = errorHandler;
  return withErrorHandler(async () => {
    const idChunks = prepareIdsForChunking(ids, COMMON_PAGE_LIMIT);
    const chunkPromises = idChunks.map(async idChunk => {
      const chunkGroups = [];
      let offset = 0;
      let hasNext = true;
      do {
        const {
          data: {
            groups,
            metadata
          }
        } = await httpClient.request(queryGroups({
          contentType: ContentType.RICH_CONTENT,
          query: {
            filter: idChunk.length > 0 ? {
              groupId: {
                $in: idChunk
              }
            } : undefined,
            paging: {
              limit: COMMON_PAGE_LIMIT,
              offset
            }
          }
        }));
        if (!(metadata != null && metadata.count)) {
          break;
        }
        offset = metadata.count + offset;
        hasNext = metadata != null && metadata.total ? offset < (metadata == null ? void 0 : metadata.total) : false;
        chunkGroups.push(...(groups ?? []));
      } while (hasNext);
      return chunkGroups;
    });
    const results = await Promise.all(chunkPromises);
    return results.flat();
  }, {
    errorCodesMap: {}
  });
};
//# sourceMappingURL=fetch-groups.js.map